export default "../media/running_deer.d5a0158695f3e7c10d1d2eb6a1ad38e7.png";